import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ServiceData } from 'store/api/services'

export interface ServicesState {
  showActiveOnly?: boolean
  showCardView?: boolean
  selectedService: ServiceData | null
  hasShownServicesWarning?: boolean
}

const initialState: ServicesState = {
  selectedService: null,
  showActiveOnly: false,
  showCardView: true,
  hasShownServicesWarning: false,
}

export const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    selectService(state, action: PayloadAction<ServiceData>): void {
      state.selectedService = action.payload
    },
    setShowActiveOnly(state, action: PayloadAction<boolean>): void {
      state.showActiveOnly = action.payload
    },
    setShowCardView(state, action: PayloadAction<boolean>): void {
      state.showCardView = action.payload
    },
    setHasShownServicesWarning(state, action: PayloadAction<boolean>): void {
      state.hasShownServicesWarning = action.payload
    },
  },
})

export const { selectService, setShowActiveOnly, setShowCardView, setHasShownServicesWarning } =
  servicesSlice.actions
